








































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import echarts from "echarts";
import {
  GetTems,
  EditTem,
  UpdateStrength,
  GetUserData,
} from "@/request/common";
@Component({
  components: {
    Header,
    LeftNav,
  },
})
export default class Name extends Vue {
  private data: any = [
    {
      name: "浮脉类",
      tip: "轻取即得",
      children: [
        {
          name: "浮脉",
          tip: "举之有余，按之不足，主表证，亦见于虚阳浮越证。",
        },
        {
          name: "洪脉",
          tip: "脉体阔大，充实有力，来盛去衰。主热盛。",
        },
        {
          name: "濡脉",
          tip: "浮细无力而软，主虚证，湿困。",
        },
        {
          name: "散脉",
          tip: "浮取散漫而无根，伴至数或脉力不匀。主元气离散，脏气将绝。",
        },
        {
          name: "芤脉",
          tip: "浮大中空，如按葱管，主失血、伤阴之际。",
        },
        {
          name: "革脉",
          tip: "浮而搏指，中空边坚，主亡血、失精、半产、崩漏。",
        },
      ],
    },
    {
      name: "沉脉类",
      tip: "重按始得",
      children: [
        {
          name: "沉脉",
          tip: "轻取不应，重按始得，主里证。",
        },
        {
          name: "伏脉",
          tip: "重按推至筋骨始得，主邪闭、厥病、痛极。",
        },
        {
          name: "弱脉",
          tip: "沉细无力而软，主阳气虚衰、气血俱虚。",
        },
        {
          name: "牢脉",
          tip: "沉按实大弦长，主阴寒内积、疝气、癥积。",
        },
      ],
    },
    {
      name: "迟脉类",
      tip: "一息不足四至",
      children: [
        {
          name: "迟脉",
          tip: "一息不足四至，主寒证，亦见于邪热结聚。",
        },
        {
          name: "缓脉",
          tip: "一息四至，脉来怠缓，主湿病，脾胃虚弱，亦见于平人。",
        },
        {
          name: "涩脉",
          tip: "往来艰涩，迟滞不畅，主精伤、血少；气滞，血瘀，痰食内停。",
        },
        {
          name: "结脉",
          tip: "迟而时一止，止无定数，主阴盛气结，寒痰瘀血，气血虚衰。",
        },
      ],
    },
    {
      name: "数脉类",
      tip: "一息五至以上",
      children: [
        {
          name: "数脉",
          tip: "一息五至以上，不足七至，主热证，亦主里虚证。",
        },
        {
          name: "疾脉",
          tip: "脉来急疾，一息七八至，主阳极阴竭，元气欲脱。",
        },
        {
          name: "促脉",
          tip: "数而时一止，止无定数，主阳热亢盛，瘀滞，痰食停积，脏气衰败。",
        },
        {
          name: "动脉",
          tip: "脉短如豆，滑数有力，主疼痛，惊恐。",
        },
      ],
    },
    {
      name: "虚脉类",
      tip: "应指无力",
      children: [
        {
          name: "虚脉",
          tip: "举按无力，应指松软，主气血两虚。",
        },
        {
          name: "细脉",
          tip: "脉细如线，应指明显，主气血俱虚，湿证。",
        },
        {
          name: "微脉",
          tip: "极细极软，似有似无，主气血大虚，阳气暴脱。",
        },
        {
          name: "代脉",
          tip: "迟而中止，止有定数，主脏气衰微；疼痛、惊恐、跌仆损伤。",
        },
        {
          name: "短脉",
          tip: "首尾俱短，不及本部，主有力主气郁，无力主气损。",
        },
      ],
    },
    {
      name: "实脉类",
      tip: "应指有力",
      children: [
        {
          name: "实脉",
          tip: "举按充实而有力，主实证；平人。",
        },
        {
          name: "滑脉",
          tip: "往来流利，应指圆滑，主痰湿、食积、实热；青壮年；孕妇。",
        },
        {
          name: "弦脉",
          tip: "端直以长，如按琴弦，主肝胆病、疼痛、痰饮等；老年健康者。",
        },
        {
          name: "紧脉",
          tip: "绷急弹指，状如转索，主实寒证、疼痛、宿食。",
        },
        {
          name: "长脉",
          tip: "首尾端直，超过本位，主阳证、热证、实证；平人。",
        },
        // {
        //   name: "大脉",
        //   tip: "脉体宽大，无汹涌之势，主健康人；病进。",
        // },
      ],
    },
  ];
  private cSetting: any = {};
  private cTab: any = "";
  private ifVisible: any = false;
  private ifReading: any = false; // 脉图设备是否已存在
  private ifOpen: any = false; // 是否打开过脉的设备
  private ifShowStrength: any = false; // 是否打开脉力设置
  private ifShowMai: any = false;
  private ifShowMaiVideo: any = false;
  private strengthData: any = {};
  private timer: any = null;
  private maiData: any = {
    cun: 20,
    guan: 20,
    chi: 20,
    data: [],
  };
  private ifShowZongshu: any = false;
  private ifShowJili: any = false;
  private tabs: any = ["中医脉学的形成与发展", "脉象形成机理", "中医切脉方法", "中医脉象八要素", "常见脉象及临床意义"];
  private activeTab: any = "中医脉学的形成与发展";
  private changeZongshuTab(tabName: string) {
    // 切换标签页时暂停所有视频
    this.pauseAllVideos();
    this.activeTab = tabName;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  // 暂停所有视频
  private pauseAllVideos() {
    const videos = [
      this.$refs.videoZongshu1,
      this.$refs.videoJili1,
      this.$refs.videoJili2,
      this.$refs.videoMaiwei,
    ] as HTMLVideoElement[];
    
    videos.forEach((video) => {
      if (video && !video.paused) {
        video.pause();
      }
    });
  }
  private openZongshu() {
    // 打开前先暂停其他所有视频
    this.pauseAllVideos();
    this.ifShowZongshu = true;
  }
  private openJili() {
    // 打开前先暂停其他所有视频
    this.pauseAllVideos();
    this.ifShowJili = true;
    // 等待DOM更新后添加视频播放事件监听
    this.$nextTick(() => {
      this.setupJiliVideoListeners();
    });
  }
  // 设置脉象形成机理弹框中两个视频的互斥播放
  private setupJiliVideoListeners() {
    const video1 = this.$refs.videoJili1 as HTMLVideoElement;
    const video2 = this.$refs.videoJili2 as HTMLVideoElement;
    
    if (video1) {
      // 先移除可能存在的旧监听器，再添加新的
      video1.removeEventListener('play', this.onJiliVideo1Play);
      video1.addEventListener('play', this.onJiliVideo1Play);
    }
    
    if (video2) {
      // 先移除可能存在的旧监听器，再添加新的
      video2.removeEventListener('play', this.onJiliVideo2Play);
      video2.addEventListener('play', this.onJiliVideo2Play);
    }
  }
  private openMaiVideo() {
    // 打开前先暂停其他所有视频
    this.pauseAllVideos();
    this.ifShowMaiVideo = true;
  }
  private closeZongshu() {
    // 暂停脉诊综述弹框中的视频
    const video = this.$refs.videoZongshu1 as HTMLVideoElement;
    if (video && !video.paused) {
      video.pause();
    }
    this.ifShowZongshu = false;
  }
  private closeJili() {
    // 暂停脉象形成机理弹框中的视频
    const video1 = this.$refs.videoJili1 as HTMLVideoElement;
    const video2 = this.$refs.videoJili2 as HTMLVideoElement;
    if (video1) {
      // 移除事件监听器
      video1.removeEventListener('play', this.onJiliVideo1Play);
      if (!video1.paused) {
        video1.pause();
      }
    }
    if (video2) {
      // 移除事件监听器
      video2.removeEventListener('play', this.onJiliVideo2Play);
      if (!video2.paused) {
        video2.pause();
      }
    }
    this.ifShowJili = false;
  }
  // video1播放时暂停video2
  private onJiliVideo1Play = () => {
    const video2 = this.$refs.videoJili2 as HTMLVideoElement;
    if (video2 && !video2.paused) {
      video2.pause();
    }
  }
  // video2播放时暂停video1
  private onJiliVideo2Play = () => {
    const video1 = this.$refs.videoJili1 as HTMLVideoElement;
    if (video1 && !video1.paused) {
      video1.pause();
    }
  }
  private closeMaiVideo() {
    // 暂停脉位弹框中的视频
    const video = this.$refs.videoMaiwei as HTMLVideoElement;
    if (video && !video.paused) {
      video.pause();
    }
    this.ifShowMaiVideo = false;
  }
  private getActiveBlocks(value: number): number {
    // 将0-255映射到0-20
    return Math.round((value / 255) * 20);
  }
  private replySure() {
    const data = JSON.parse(JSON.stringify(this.cSetting.data));
    data["脉诊设置"]["寸"] = this.cSetting["寸"];
    data["脉诊设置"]["关"] = this.cSetting["关"];
    data["脉诊设置"]["尺"] = this.cSetting["尺"];
    data["脉诊设置"]["脉压"] = this.cSetting["脉压"];
    data["脉诊设置"]["脉幅"] = this.cSetting["脉幅"];
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    EditTem(this, data, loading)
      .then((res: any) => {
        loading.close();
        this.ifVisible = false;
        this.$message.success("保存成功");
        this.getData();
      })
      .catch(() => {
        loading.close();
      });
  }
  private openMai(val: any) {
    this.timer = null;
    this.maiData = {
      originData: val,
      maitu: val.data["脉象图谱"] || {},
      tip: val.tip,
      cun: val.data["脉诊设置"]["寸"] || 20,
      guan: val.data["脉诊设置"]["关"] || 20,
      chi: val.data["脉诊设置"]["尺"] || 20,
      data: val.data["脉象波形数据"]
        ? JSON.parse(val.data["脉象波形数据"])
        : [],
    };
    console.log(this.maiData);
    // 设置波形数据的默认值
    if (!this.maiData.data || this.maiData.data.length == 0) {
      this.maiData.data = [
        [0, 0],
        [4, 2],
        [9, 7],
        [11, 15],
        [20, 70],
        [34, 40],
        [58, 38],
        [77, 24],
        [94, 26],
        [113, 13],
        [143, 4],
        [158, 4],
        [170, 1],
        [180, 0],
      ];
    }
    this.ifShowMai = true;
    this.$nextTick(() => {
      const Chart: any = echarts.init(this.$refs.mai as HTMLCanvasElement);
      const options: any = {
        color: "#1B5AB2",
        yAxis: {
          type: "value",
          show: true,
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "solid",
              color: "#E9E9E9",
            },
          },
        },
        xAxis: {
          type: "category",
          show: false,
          data: [],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            data: [],
            type: "line",
            showSymbol: false,
            smooth: true,
            smoothMonotone: "x", // 保持曲线单调性
            lineStyle: {
              width: 2, // 加粗线条
            },
            animation: false, // 关闭动画使移动更流畅
          },
        ],
      };
      Chart.setOption(options);
      if (!this.maiData.data || this.maiData.data.length == 0) {
        return;
      }

      let currentIndex = 0;
      const data = this.maiData.data;
      const pointsPerFrame = 1; // 降低每次移动的点数
      const totalPoints = 40; // 增加显示的点数，使曲线更完整

      this.timer = setInterval(() => {
        const xData = [];
        const yData = [];

        for (let i = 0; i < totalPoints; i++) {
          const dataIndex = (currentIndex + i) % data.length;
          xData.push(data[dataIndex][0]);
          yData.push(data[dataIndex][1]);
        }

        Chart.setOption({
          xAxis: {
            data: xData,
          },
          series: [
            {
              data: yData,
            },
          ],
        });

        currentIndex = (currentIndex + pointsPerFrame) % data.length;
      }, 400); // 降低更新频率
    });
  }
  private closeMai() {
    // 关闭定时器
    clearInterval(this.timer);
    this.ifShowMai = false;
    console.log("停止", "control_hand", "stop");
    const result = window.electronMyAPI.changePulse(
      "停止",
      "control_hand",
      "stop"
    );
    console.log(result);
  }
  private openStrength() {
    this.strengthData = JSON.parse(JSON.stringify(this.user["取脉力度"]));
    this.ifShowStrength = true;
  }
  private resetStrength() {
    this.strengthData = {
      浮: 60,
      中: 120,
      沉: 180,
      重沉: 240,
    };
    this.strengthSure();
  }
  private strengthSure() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      target_user_id: this.user.user_id,
      取脉力度: this.strengthData,
    };
    UpdateStrength(this, params, loading).then((res: any) => {
      loading.close();
      this.ifShowStrength = false;
      this.$message.success("保存成功");
      this.getUserData();
    });
  }
  private getUserData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetUserData(this, loading).then((res: any) => {
      loading.close();
      this.$store.commit("updateUser", res);
    });
  }
  private goSetting(item: any) {
    this.cSetting = {
      data: item.data,
      name: item.name,
      寸: item.data["脉诊设置"]["寸"] || 20,
      关: item.data["脉诊设置"]["关"] || 20,
      尺: item.data["脉诊设置"]["尺"] || 20,
      脉压: item.data["脉诊设置"]["脉压"] || 20,
      脉幅: item.data["脉诊设置"]["脉幅"] || 20,
    };
    this.ifVisible = true;
  }
  private reset() {
    this.cSetting["寸"] = 20;
    this.cSetting["关"] = 20;
    this.cSetting["尺"] = 20;
    this.cSetting["脉压"] = 20;
    this.cSetting["脉幅"] = 20;
  }
  private async changeTab(val: any) {
    // 如果支持设备脉，需要调取exe调整设备脉
    if (this.systemInfo.SETTING.iFHasDevicePulse) {
      if (this.ifReading) {
        console.log(val.name, "control_hand", "start");
        const result = await window.electronMyAPI.changePulse(
          val.name,
          "control_hand",
          "start"
        );
        console.log(result);
        const loading2 = this.$loading({
          lock: true,
          text: "脉象切换中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        if (result) {
          this.ifOpen = true;
          this.cTab = val.name;
          this.openMai(val);
          loading2.close();
          console.log("返回值：" + result);
        }
      } else {
        console.log("检查", "check_hand", "检查");
        const checkResult = await window.electronMyAPI.changePulse(
          "检查",
          "check_hand",
          "检查"
        );
        console.log(checkResult);
        console.log(checkResult == "success");
        const loadingCheck = this.$loading({
          lock: true,
          text: "设备检查中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        if (checkResult) {
          if (checkResult == "success") {
            this.cTab = val.name;
            this.ifReading = true;
            loadingCheck.close();
            console.log(val.name, "control_hand", "start");
            const result = await window.electronMyAPI.changePulse(
              val.name,
              "control_hand",
              "start"
            );
            console.log(result);
            const loading2 = this.$loading({
              lock: true,
              text: "脉象切换中……",
              spinner: "el-icon-loading",
              customClass: "loadClass",
              background: "rgba(255, 255, 255, 0.7)",
            });
            if (result) {
              this.ifOpen = true;
              this.maiData = val;
              this.openMai(val);
              loading2.close();
              console.log("返回值：" + result);
            }
          } else {
            console.log("333");
            loadingCheck.close();
            alert("设备不存在");
          }
        }
      }
    } else {
      this.cTab = val.name;
      this.maiData = val;
      this.openMai(val);
    }
  }

  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      类别: "脉",
      current_page: 1,
      page_count: 999,
    };
    GetTems(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = [];
        // 处理数据，将数据处理成当前data一样的格式
        let otherData: any = { name: "其它", tip: " ", children: [] };

        res.data.forEach((items: any) => {
          items.data.forEach((ele: any) => {
            const option = ele.options.find(
              (item: any) => item.value === ele.correct
            );
            const val: any = option ? option.label : "";
            const obj: any = {
              data: items,
              name: val,
              tip: items["备注"],
            };
            if (!items["脉诊实训分类"]) {
              otherData.children.push(obj);
            } else {
              // 寻找this.data中name相同的对象
              const index = this.data.findIndex(
                (item: any) => item.name == items["脉诊实训分类"]
              );
              if (index != -1) {
                this.data[index].children.push(obj);
              } else {
                this.data.push({
                  name: items["脉诊实训分类"],
                  tip: "",
                  children: [obj],
                });
              }
            }
          });
        });
        if (otherData.children.length > 0) {
          this.data.push(otherData);
        }
      })
      .catch(() => {
        loading.close();
      });
  }

  mounted() {
    this.getData();
  }
  private beforeDestroy(to: any, from: any, next: any) {
    if (this.ifOpen) {
    }
  }
}
